module.exports = __webpack_public_path__ + "img/pro_detail_5.564f4b37.jpg";